var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('youtube',{ref:"youtube",attrs:{"height":"290","width":"100%","video-id":_vm.stream_info.channel_name,"player-vars":_vm.playerVars,"resize":""}})}
var staticRenderFns = []

export { render, staticRenderFns }